import { Component } from 'react';

import {
    FormattedDate,
    WrappedComponentProps,
    injectIntl,
    FormattedMessage
} from 'react-intl';

import { TextWithIcon } from '../textWithIcon';
import styles from './NextRepaymentText.module.css';
import { FormattedCurrency } from '../../../../../iwIntlProvider/FormattedCurrency';
import { CalendarTickSVG } from '../../../../../svgComponents/calendarTickSVG/index';
import { TooltipExclamationMarkSVG } from '../../../../../svgComponents/tooltipExclamationMarkSVG/index';

type TProps = {
    isPaymentOverdue?: any;
    amount: number;
    date: string;
    locale: object;
    totalBalance: number;
};

class NextRepaymentText extends Component<TProps & WrappedComponentProps> {
    getIcon() {
        const { isPaymentOverdue } = this.props;

        if (isPaymentOverdue) {
            return <TooltipExclamationMarkSVG className={styles.overdueText} />;
        }
        return <CalendarTickSVG />;
    }

    getCustomStyles() {
        const { isPaymentOverdue } = this.props;

        if (isPaymentOverdue) {
            return styles.overdueText;
        }
        return null;
    }

    render() {
        const {
            amount,
            date,
            intl: { formatMessage },
            isPaymentOverdue
        } = this.props;
        const icon = this.getIcon();
        const customStyles = this.getCustomStyles();

        return (
            <TextWithIcon
                className={customStyles}
                icon={icon}
                text={
                    isPaymentOverdue ? (
                        <FormattedMessage
                            id="_.dashboard.status.lines_next_repayment_overdue"
                            defaultMessage="Your next repayment of {amount} is overdue. Please make a payment or get in touch if you're not able to - we might be able to {unableToPayLink} it."
                            values={{
                                amount: <FormattedCurrency value={amount} />,
                                unableToPayLink: (
                                    <a
                                        href={formatMessage({
                                            id: '_.dashboard.status.lines_next_repayment_overdue_unable_to_pay_link',
                                            defaultMessage:
                                                'https://support.iwoca.co.uk/en/articles/1608757-what-happens-if-i-m-unable-to-make-an-upcoming-repayment-due-to-the-corona-crisis'
                                        })}
                                        rel="noopener noreferrer"
                                        className={styles.link}
                                        target="_blank"
                                    >
                                        {formatMessage({
                                            id: '_.dashboard.status.lines_next_repayment_overdue_unable_to_pay_link_text',
                                            defaultMessage: 'delay or reduce'
                                        })}
                                    </a>
                                )
                            }}
                        />
                    ) : (
                        <FormattedMessage
                            id="_.dashboard.status.lines_next_repayment"
                            defaultMessage="Your next payment of {amount} will be collected on {date}"
                            values={{
                                amount: <FormattedCurrency value={amount} />,
                                date: (
                                    <FormattedDate
                                        day="numeric"
                                        month="long"
                                        year="numeric"
                                        value={new Date(date)}
                                    />
                                )
                            }}
                        />
                    )
                }
            />
        );
    }
}

// eslint-disable-next-line import/no-default-export
export default injectIntl(NextRepaymentText);
